import { Outlet } from 'react-router-dom';
import ShopifyAdminSidebar from './_Components/ShopifyAdminSidebar';

export default function ShopifyAdminLayout() {
  return (
    <div className="flex h-full bg-gray-50 dark:bg-gray-900">
      <ShopifyAdminSidebar />
      <div className="flex-1 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
